// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yog9","badges":"styles_badges__1Srh1"};